<template>
    <v-dialog persistent no-click-animation v-model="show" max-width="400px">
        <div class="InputTextDialog">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ title | capitalize }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar">
                <v-form ref="form" v-model="formValid" @submit="submit">
                    <v-text-field
                        v-model="value"
                        :rules="formRules.required"
                        class="input-custom"
                    ></v-text-field>
                </v-form>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-custom"
                     @click="submit">{{ $f.tc('done') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import {AppServiceEventBus, AppServiceEventBusType} from '@/eventbus/appservice.eventbus'

export default {
    name: 'InputTextDialog',
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            title: '',
            value: ''
        }
    },
    methods: {
        willOpen(title) {
            this.title = title
        },
        submitValidForm() {
            this.promise.resolve(this.value)
            AppServiceEventBus.$emit(AppServiceEventBusType.INPUT_TEXT_DONE, this.value)
            this.close()
        }
    }
}
</script>

<style scoped lang="scss">
.InputTextDialog {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        padding: 12px;
        max-height: 500px;
        overflow-y: auto;
    }

    .btn-custom {
        margin-right: 8px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}
</style>
